import axios from 'axios';
import axiosRetry from './node_modules-axios-retry-dist-esm-index.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
const _AxiosProvider = class _AxiosProvider {
  static getDefaultInstance() {
    if (_AxiosProvider.instance == null) {
      _AxiosProvider.instance = axios.create();
      axiosRetry(_AxiosProvider.instance);
    }
    return _AxiosProvider.instance;
  }
  static createRetryInstance(retryPolicy) {
    const client = axios.create();
    retryPolicy != null ? axiosRetry(client, retryPolicy) : axiosRetry(client);
    return client;
  }
};
__publicField(_AxiosProvider, "instance");
let AxiosProvider = _AxiosProvider;
const defaultAxios = AxiosProvider.getDefaultInstance();

export { AxiosProvider, defaultAxios as default };
//# sourceMappingURL=src-providers-axios-provider.js.map
